import { createFileRoute } from '@tanstack/react-router'
import { Outcomes } from '@/features/outcomes'

export const Route = createFileRoute('/_authenticated/outcomes/')({
  validateSearch: (search: Record<string, unknown>) => ({
    outcomeId:
      typeof search.outcomeId === 'number'
        ? search.outcomeId
        : typeof search.outcomeId === 'string' && /^\d+$/.test(search.outcomeId)
          ? Number(search.outcomeId)
          : undefined,
  }),
  component: OutcomesRoute,
})

function OutcomesRoute() {
  const { outcomeId } = Route.useSearch()
  return <Outcomes key={outcomeId ?? 'list'} initialOutcomeId={outcomeId} />
}
